import Vue from "vue";
import Router from "vue-router";

import store from "./store";
import routes from "@/routes.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: routes.definition,
});

function getAllowedRoute(to, next) {
  var routeMetas = to.meta;
  var user = store.state.user;
  var isAuthenticated = store.state.isAuthenticated;
  var nextPage = next;
  var authorizedToGo = false;

  if (routeMetas.access !== undefined) {
    // route accessible uniquement aux utilisateurs non-authentifiés
    if (routeMetas.access.type === "anonymous") {
      // si l'utilisateur a accès et est authentifié
      if (isAuthenticated) {
        // renvoie vers page "non autorisé"
        nextPage = "/unauthorized";
      }
    }
    // route accessible uniquement aux utilisateurs authentifiés
    else if (routeMetas.access.type === "authenticated") {
      // si l'utilisateur n'est pas authentifié
      if (!isAuthenticated) {
        nextPage = false;
        // en attendant la redirection vers processus de connexion
        window.location =
          process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_LOGIN +
          "?uriRedirect=" +
          to.path;
      } else {
        authorizedToGo = true;
        // si des rôles sont définis, la route ne doit être ouverte qu'aux connectés ayant un de ces rôles
        if (Array.isArray(routeMetas.access.roles)) {
          // on bloque par défaut l'accès à cette route avant de contrôler
          authorizedToGo = false;
          user.roles.forEach((userRole) => {
            if (routeMetas.access.roles.indexOf(userRole) > -1) {
              authorizedToGo = true;
            }
          });
        }
        // si utilisateur non autorisé à accéder à la ressource
        if (!authorizedToGo) {
          nextPage = "/unauthorized";
        }
      }
    }
  }

  return nextPage;
}

// contrôle d'accès aux pages suivant la définition des routes
router.beforeEach(async (to, from, next) => {
  // si la destination n'est pas la page d'erreur
  try {
    // si utilisateur non authentifié, on contacte l'API ./api/account
    if (store.state.user === null) {
      await store.dispatch("loadUser").then(() => {
        next(getAllowedRoute(to, next));
      });
    } else {
      next(getAllowedRoute(to, next));
    }
  } catch (error) {
    // si erreur (ex. l'API renvoie un 404), envoie vers la page d'erreur globale de l'application
    let erreurRoute = router.options.routes.filter((route) => {
      return route.name === "erreur";
    })[0];
    erreurRoute.props.message =
      "Les informations de votre compte n'ont pas pu être récupérées";
    next(getAllowedRoute(erreurRoute, next));
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title;
  });
});

export default router;
